import { Button, Text, type TextWeight } from '@/components';
import { ExportOutlined } from '@ant-design/icons';
import type { FC } from 'react';

type Props = {
  name: string;
  src?: string;
  weight?: TextWeight;
  width?: string;
};

export const AttachmentNameWithOpenButton: FC<Props> = ({
  name,
  src,
  weight,
  width,
}) => {
  return src ? (
    <Button
      type="link"
      size="small"
      icon={<ExportOutlined />}
      onClick={() => {
        window.open(src, '_blank');
      }}
      style={{
        padding: 0,
        width,
        justifyContent: 'flex-start',
        overflow: 'hidden',
      }}
    >
      <Text
        text={name}
        weight={weight}
        ellipsis
        maxWidth="90%"
        color="primary"
      />
    </Button>
  ) : (
    <Text text={name} weight={weight} ellipsis maxWidth="100%" />
  );
};
